import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import SubmitCase from "@/pages/SubmitCase";
import Analysis from "@/pages/Analysis";
import Dashboard from "@/pages/Dashboard";
import Search from "@/pages/Search";
import AttorneyEscalation from "@/pages/AttorneyEscalation";
import LawFirms from "@/pages/LawFirms";
import FirmPortal from "@/pages/FirmPortal";
import CheckoutResult from "@/pages/CheckoutResult";
import SolvedCases from "@/pages/SolvedCases";
import SolvedCaseDetail from "@/pages/SolvedCaseDetail";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import SeoLanding from "@/pages/SeoLanding";
import Firms from "@/pages/Firms";
import WidgetEmbed from "@/pages/WidgetEmbed";
import AdminDashboard from "@/pages/AdminDashboard";
import Courtroom from "@/pages/Courtroom";
import AdPackage from "@/pages/AdPackage";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import RefundPolicy from "@/pages/RefundPolicy";
import Contact from "@/pages/Contact";
import Expungement from "@/pages/Expungement";
import DemandLetter from "@/pages/DemandLetter";
import Telemetry from "@/components/Telemetry";

function App() {
    return (
        <div className="App bg-[#0a0a0a] min-h-screen text-white">
            <BrowserRouter>
                <Telemetry />
                <Routes>
                    <Route path="/" element={<Navigate to="/hpm" replace />} />
                    <Route path="/hpm" element={<Landing />} />
                    <Route path="/hpm-submit" element={<SubmitCase />} />
                    <Route path="/hpm-analysis/:id" element={<Analysis />} />
                    <Route path="/hpm-dashboard" element={<Dashboard />} />
                    <Route path="/hpm-search" element={<Search />} />
                    <Route path="/attorney-escalation/:caseId" element={<AttorneyEscalation />} />
                    <Route path="/hpm-law-firms" element={<LawFirms />} />
                    <Route path="/firm-portal" element={<FirmPortal />} />
                    <Route path="/checkout/hpm" element={<CheckoutResult />} />
                    <Route path="/hpm-cases/solved" element={<SolvedCases />} />
                    <Route path="/hpm-cases/solved/:caseId" element={<SolvedCaseDetail />} />
                    <Route path="/hpm-blog" element={<Blog />} />
                    <Route path="/hpm-blog/:slug" element={<BlogPost />} />
                    <Route path="/lawyer/:state/:practice" element={<SeoLanding />} />
                    <Route path="/hpm-firms" element={<Firms />} />
                    <Route path="/hpm-widget" element={<WidgetEmbed />} />
                    <Route path="/hpm-admin" element={<AdminDashboard />} />
                    <Route path="/courtroom" element={<Courtroom />} />
                    <Route path="/ad-package" element={<AdPackage />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/refund-policy" element={<RefundPolicy />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/hpm-expungement" element={<Expungement />} />
                    <Route path="/demand-letter" element={<DemandLetter />} />
                    <Route path="*" element={<Navigate to="/hpm" replace />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="top-right"
                theme="dark"
                toastOptions={{
                    style: {
                        background: "#0a0a0a",
                        color: "#fff",
                        border: "2px solid #ff3b30",
                        borderRadius: 0,
                        fontFamily: "IBM Plex Mono, monospace",
                    },
                }}
            />
        </div>
    );
}

export default App;
